export default "__VITE_ASSET__CQFuUh50__"